import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { AccessibilityButton } from '@skillz/accessibility';
import { changeLang } from '../../../store/redux/translate-actions';
import Tooltip from '../tooltip/Tooltip'
import classes from "./TranslateBtns.module.css"

const TranslateBtns = ({ color, dropClass }) => {

    const { lang } = useSelector(state => state.translate);
    const { texts } = useSelector(state => state.translate);
    const dispatch = useDispatch()

    return (
        <div className={`${classes.TranslateBtns} ${dropClass}`}>
            <Tooltip text={texts.he} showTooltip={true}>
                <AccessibilityButton accessibilityDescription={texts.he || 'hebrew'} className={`${classes.LangBtn} ${lang === "he" ? classes.CurrentLang : ""}`} onClick={() => dispatch(changeLang("he"))}>ע</AccessibilityButton>
            </Tooltip>
            <Tooltip text={texts.ar} showTooltip={true}>
                <AccessibilityButton accessibilityDescription={texts.ar || 'arabic'} className={`${classes.LangBtn} ${lang === "ar" ? classes.CurrentLang : ""}`} onClick={() => dispatch(changeLang("ar"))}>ع</AccessibilityButton>
            </Tooltip>
        </div>
    )
}

export default TranslateBtns